import { timestampToString } from "../../util/timestamp";

export default function PaymentDetail({ payment }) {
  const classNames = () => {
    let classes =
      "pill grid grid-cols-8 ";
    if (payment.status === "succeeded") classes += "border-green-600";
    if (payment.status === "approved") classes += "border-blue-600";
    if (payment.status === "declined") classes += "border-red-600";
    if (payment.status === "pending") classes += "border-yellow-600";
    return classes;
  };
  return (
    <div className={classNames()}>
      <p className="font-semibold">
        {timestampToString(
          payment.date_paid || payment.date_created,
          "do MMM hh:mm a"
        )}
      </p>
      {payment.vehicle ? <p className="truncate text-stone-200">{payment.vehicle?.year} {payment.vehicle?.make} {payment.vehicle?.model}</p> : <p>-</p>}
      <p className="truncate md:col-span-2 text-stone-200">{payment.description}</p> 
      {payment.attachment ? (
        <a
          href={payment.attachment || "-"}
          target="_blank"
          className="mx-auto text-yellow-600 underline"
        >
          Attachment
        </a>
      ) : (
        <p className="mx-auto text-stone-400">-</p>
      )}
      {payment.receipt ? (
        <a
          href={payment.receipt || "-"}
          target="_blank"
          className="mx-auto text-yellow-600 underline"
        >
          Receipt
        </a>
      ) : (
        <p className="mx-auto text-stone-400">-</p>
      )}
      <p className="font-semibold text-right text-white">${Number(payment.amount).toFixed(2)}</p>
      <p className="font-semibold text-right">{payment.status === "pending" ? "PENDING" : "PAID"}</p>
    </div>
  );
}
